import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ClerkProvider, SignedIn, SignedOut } from '@clerk/clerk-react';
import AIWebinarPage from './AIWebinar/AIWebinarPage';
import AIWebinarPageES from './AIWebinar/AIWebinarPageES';
import AIWebinarTestimonial from './AIWebinar/AIWebinarTestimonial';
import AIWebinarTestimonialES from './AIWebinar/AIWebinarTestimonialES';
import SoftwarePage from './Software/SoftwarePage';
import PaymentSuccess from './Software/PaymentSuccessPage';
import CalendarAIConsultation from './Software/CalendarAIConsultation';
import BusinessConsultation from './Software/BusinessConsultation';
import DirectSellingPage from './DirectSelling/DirectSellingPage';
import ZoomPage from './Zoom/ZoomMeeting';
import ZoomExplanation from './Zoom/ZoomExplanation';
import AsteroidsGame from './Asteroids/AsteroidsGame';
import SpaceshipGame from './Spaceship/SpaceshipGame';
import Space from './Space/Space';
import CustomSoftwarePage from './CustomSoftware/CustomSoftwarePage';
import TaskManager from './TaskManager/TaskManager';
import LoginPrompt from './TaskManager/LoginPrompt';
import ResumeEditor from './ResumeEditor/ResumeEditor';
import DemoVideo from './DemoVideo/DemoVideo';
import './ResumeEditor/openaiKeyLoader'; // Import the OpenAI API key loader
import config from './config';

// Get the Publishable Key from config or environment
const PUBLISHABLE_KEY = config.auth?.clerkPublishableKey || process.env.REACT_APP_CLERK_PUBLISHABLE_KEY || '';

if (!PUBLISHABLE_KEY) {
  console.warn('Missing Clerk Publishable Key. Authentication features will be disabled.');
}

// Determine if authentication is enabled
const isAuthEnabled = !!PUBLISHABLE_KEY;

// Protected route component - only enforce if auth is enabled
const ProtectedRoute = ({ children }) => {
  // If auth is not enabled, just render the children
  if (!isAuthEnabled) {
    return children;
  }
  
  return (
    <>
      <SignedIn>{children}</SignedIn>
      <SignedOut>
        <LoginPrompt />
      </SignedOut>
    </>
  );
};

// Conditionally render with or without Clerk provider
const AppWithRoutes = () => (
  <Router>
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/software" element={<SoftwarePage />} />
      <Route path="/software/payment-success" element={<PaymentSuccess />} />
      <Route path="/calendar-ai-consultation" element={<CalendarAIConsultation />} />
      <Route path="/business-consultation" element={<BusinessConsultation />} />
      <Route path="/direct-selling" element={<DirectSellingPage />} />
      <Route path="/ai-webinar" element={<AIWebinarPage />} />
      <Route path="/ai-webinar/es" element={<AIWebinarPageES />} />
      <Route path="/ai-webinar-testimonial" element={<AIWebinarTestimonial />} />
      <Route path="/ai-webinar-testimonial/es" element={<AIWebinarTestimonialES />} />
      <Route path="/zoom" element={<ZoomPage />} />
      <Route path="/zoom-explanation" element={<ZoomExplanation />} />
      <Route path="/asteroids" element={<AsteroidsGame />} />
      <Route path="/spaceship" element={<SpaceshipGame />} />
      <Route path="/space" element={<Space />} />
      <Route path="/custom-software" element={<CustomSoftwarePage />} />
      <Route path="/task-manager" element={
        <ProtectedRoute>
          <TaskManager />
        </ProtectedRoute>
      } />
      <Route path="/resume-editor" element={<ResumeEditor />} />
      <Route path="/demo-video" element={<DemoVideo />} />
    </Routes>
  </Router>
);

const root = ReactDOM.createRoot(document.getElementById('root'));

// Conditionally render with or without Clerk provider based on whether we have a key
root.render(
  <React.StrictMode>
    {isAuthEnabled ? (
      <ClerkProvider publishableKey={PUBLISHABLE_KEY} afterSignOutUrl='/'>
        <AppWithRoutes />
      </ClerkProvider>
    ) : (
      <AppWithRoutes />
    )}
  </React.StrictMode>
);

reportWebVitals();